import React from 'react';
import moment from 'moment';
import { Badge } from 'react-bootstrap';
import { Button } from '../../../common-components/Button/Button';
import { ReportJobQueue } from '../../../models/ReportJobQueue';
import { JobStatus, jobStatusMapper } from '../../../enums/JobStatus';
import { reportJobTypeMapper } from '../../../enums/ReportJobType';
import { Container, ReportName, Result, SimpleRow, SpacedRow, Status } from './style';

interface IReportJobQueueCardProps {
  reportJobQueue: ReportJobQueue;
  cancel: () => void;
}

export const ReportJobQueueCard: React.FC<IReportJobQueueCardProps> = ({ reportJobQueue, cancel }) => { 

  return (
    <Container>
      <SpacedRow>
        <Status>Criado em {moment(reportJobQueue.createdAt).format('DD/MM/YYYY HH:mm:ss')} por {reportJobQueue.userName}</Status>
      </SpacedRow>
      <SimpleRow>
        <ReportName>{reportJobTypeMapper[reportJobQueue.reportType]}</ReportName>
        <Badge pill bg='secondary' style={{fontSize:10, marginLeft:10}}>{reportJobQueue.id}</Badge>
      </SimpleRow>
      <SpacedRow>
        {reportJobQueue.status == JobStatus.CancelledByUser ? 
          <Status>Cancelado por {reportJobQueue.cancelledByName} em {moment(reportJobQueue.statusDate).format('DD/MM/YYYY HH:mm:ss')}</Status> : null}
        {reportJobQueue.status == JobStatus.Error ? 
          <Status>{jobStatusMapper[reportJobQueue.status]} {reportJobQueue.statusDetail ? ` - ${reportJobQueue.statusDetail}` : ''}</Status> : null}
        {reportJobQueue.status == JobStatus.Pending || reportJobQueue.status == JobStatus.Running ? 
          <Status>Aguarde, gerando...</Status> : null}
        {reportJobQueue.status == JobStatus.Performed && reportJobQueue.result ? 
          <Result><a href={reportJobQueue.result} target='_blank'>Resultado</a></Result> : null}
        {reportJobQueue.status == JobStatus.Pending || reportJobQueue.status == JobStatus.Running ? (
          <Button text='Cancelar' type='danger' click={cancel}/>
        ) : null}
      </SpacedRow>
    </Container>
  );
}